'use strict';

function controller (sellerService) {
    const ctrl = this;

    function init() {
        sellerService.getSeller().then(sellerResponse => {
            ctrl.seller = sellerResponse.data.sellerDto;
        });
    }

    init();

}

controller.$inject = [
    'sellerService'
];

export default controller;